import {
  Modal,
  PrimaryBlueButton,
  PrimaryGrayButton,
  Toggle
} from "@velaro/velaro-component-lib";
import React, { useState } from "react";
import AIChatbotSettingsRow from "./AIChatbotSettingsRow";
import { AzureIndex } from "../types";
import AIChatbotSettingsRowToggle from "./AIChatbotSettingsRowToggle";
import useSubscriptions from "@/hooks/useSubscriptions";

interface Props {
  tempSearchIndex: AzureIndex;
  clearSearchModal(): void;
  CreateIndex(index: AzureIndex): void;
}

export default function CreateIndexModal(props: Props) {
  const [tempSearchIndex, setTempSearchIndex] = useState<AzureIndex>(
    props.tempSearchIndex
  );
  const { subscription } = useSubscriptions();
  return (
    <Modal maxWidth="max-w-2xl" show={true}>
      <div className="bg-white p-4 rounded-2xl w-full self-center mt-2">
        <div className="font-semibold text-lg pb-1">Create Index</div>
        <div className="">
          <AIChatbotSettingsRow
            title="Index Name"
            subtitle="A unique name for the index"
            input={
              <input
                value={tempSearchIndex.name || ""}
                onChange={(e) => {
                  setTempSearchIndex({
                    ...tempSearchIndex!,
                    name: e.target.value
                  });
                }}
                type="text"
                placeholder={""}
                className="w-full p-2 border-[1px] rounded-md text-sm"
              />
            }
          />
          <AIChatbotSettingsRow
            title="Search Size"
            subtitle="Number of search results to return"
            input={
              <input
                value={tempSearchIndex.searchSize}
                onChange={(e) => {
                  setTempSearchIndex({
                    ...tempSearchIndex!,
                    searchSize: e.target.valueAsNumber
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key) {
                    e.preventDefault();
                    return;
                  }
                }}
                type="number"
                min="1"
                max="9"
                placeholder={""}
                className="w-full p-2 border-[1px] rounded-md text-sm"
              />
            }
          />
          {subscription?.enableSemanticSearch && (
            <AIChatbotSettingsRowToggle
              title="Enhanced AI Search"
              subtitle="Enable AI to enhance search results"
              input={
                <Toggle
                  toggled={tempSearchIndex.semanticSearchEnabled}
                  changeToggle={() =>
                    setTempSearchIndex({
                      ...tempSearchIndex!,
                      semanticSearchEnabled:
                        !tempSearchIndex.semanticSearchEnabled
                    })
                  }
                />
              }
            />
          )}
        </div>
        <div className="flex justify-end mt-6 gap-6">
          <PrimaryGrayButton
            label="Cancel"
            onClick={() => props.clearSearchModal()}
          />
          <PrimaryBlueButton
            label="Create"
            onClick={() => props.CreateIndex(tempSearchIndex)}
          />
        </div>
      </div>
    </Modal>
  );
}
